import Model from '../Model'
export default class County extends Model {

    resource()
    {
        return 'staticdata/counties'
    }
}
